import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subsidyTypeFilter, subsidyTypeFilterSelection } from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const SubsidyTypeFilter = ({ id, pending }: Props) => (
  <PlainItemsSelectorBox
    id={id}
    label="Вид справки"
    header="Выбор вида справки"
    dataBoxData={subsidyTypeFilter}
    dataBoxSelection={subsidyTypeFilterSelection}
    pleaseSelectText="Нет данных"
    selectedAllOnEmptySelection
    multiple
    disabled={pending}
  />
)
